import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Email from '../assets/email.png';
import Phone from '../assets/phone.png';
import { pageAction } from '../redux_files/actions/page_actions';
import { getDeviceType } from '../utils/common';
import ContactForm  from '../components/contact-form';

const Contactus = () => {
  const dispatch = useDispatch();
  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    document.title = 'Contact Us';
    dispatch(pageAction('Contact Us'));
  });
  useEffect(() => {
      window.addEventListener('resize', setDeviceType(getDeviceType()));
      return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
  }, []);
  
  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          <br />
          <div className='row'>
            <div className={`col align-to-center display-flex text-center ${deviceType === "mobile" ? 'wd-100' : 'wd-50'}`}>
              <a href="mailto:info@shivaydurga.com">
                <img src={Email} alt='Email Us' width="50%" />
              </a>
              <a href="mailto:info@shivaydurga.com">info@shivaydurga.com</a>
            </div>
            {deviceType === "mobile" && <br />}
            <div className={`col align-to-center display-flex text-center ${deviceType === "mobile" ? 'wd-100' : 'wd-50'}`}>
              <a href='tel:+919996212490'>
                <img src={Phone} alt='Call Us' width="50%" />
              </a>
              <br />
              <a href='tel:+919996212490'>+919996212490</a>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </>
  );
};

export default Contactus;
